"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromotionsService = void 0;
var config_1 = require("../config/config");
var types_1 = require("../models/draws/types");
var ProgressivePrize_1 = require("../models/promotion/ProgressivePrize");
var Promotion_1 = require("../models/promotion/Promotion");
var api_1 = require("./api");
var util_1 = require("./util");
var PATH = 'promotion/api';
var PromotionsService = /** @class */ (function () {
    function PromotionsService() {
    }
    PromotionsService.fetchSecondChancePromotions = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.fetchPromotions(request, types_1.PromotionType.SECOND_CHANCE.toString())];
            });
        });
    };
    PromotionsService.fetchProgressivePromotions = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.fetchPromotions(request, types_1.PromotionType.PROGRESSIVE.toString())];
            });
        });
    };
    PromotionsService.fetchPromotions = function (request, type) {
        return __awaiter(this, void 0, void 0, function () {
            var page, size, sort, requestParams, url, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!type)
                            type = types_1.PromotionType.SECOND_CHANCE.toString() + "," + types_1.PromotionType.PROGRESSIVE.toString();
                        page = request.page, size = request.size, sort = request.sort;
                        requestParams = ["page=" + (page || 0), "size=" + (size || 10)];
                        if (sort) {
                            requestParams.push("sort=" + sort);
                        }
                        else {
                            requestParams.push("sort=order,desc");
                            requestParams.push("sort=name,asc");
                        }
                        url = PATH + "/v1/promotions?promotionType.in=" + type + "&" + requestParams.join('&');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, util_1.formatResponse(url, request.query, Promotion_1.Promotion.JsonToEntities)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_1 = _a.sent();
                        throw error_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    PromotionsService.fetchPromotionDetails = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = PATH + "/v1/promotions/" + id;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api_1.API.get({ url: url })];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, Promotion_1.Promotion.JsonToEntity(response)];
                    case 3:
                        error_2 = _a.sent();
                        throw error_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    PromotionsService.fetchProgressivePrize = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = PATH + "/v1/promotion/" + id + "/prizes";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api_1.API.get({ url: url })];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, ProgressivePrize_1.ProgressivePrize.JsonToEntity(response)];
                    case 3:
                        error_3 = _a.sent();
                        throw error_3;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    PromotionsService.fetchActiveDraw = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var url, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = PATH + "/v1/promotion/" + id + "/active-draw";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api_1.API.get({ url: url })];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_4 = _a.sent();
                        throw error_4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    PromotionsService.claimFreeEntryForGuest = function (userData, promotionId) {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.post({
                                url: PATH + "/v2/entries/free",
                                body: userData.getPostRequest(promotionId, config_1.react_core_config.internalConfig.lotteryId)
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_1 = _a.sent();
                        throw e_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    PromotionsService.claimFreeEntryForGuestNoCaptcha = function (userData, promotionId) {
        return __awaiter(this, void 0, void 0, function () {
            var e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.post({
                                url: PATH + "/v2/entries/" + promotionId + "/free",
                                body: userData.getPostRequest(promotionId, config_1.react_core_config.internalConfig.lotteryId)
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_2 = _a.sent();
                        throw e_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    PromotionsService.claimFreeEntry = function (promotionId) {
        return __awaiter(this, void 0, void 0, function () {
            var e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.get({
                                url: PATH + "/v2/entries/" + promotionId + "/free"
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_3 = _a.sent();
                        throw e_3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    PromotionsService.countFreeEntry = function (drawId) {
        return __awaiter(this, void 0, void 0, function () {
            var e_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.get({
                                url: PATH + "/v2/entries/" + drawId + "/free/count"
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_4 = _a.sent();
                        throw e_4;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    PromotionsService.fetchPrizesByDraw = function (drawId) {
        return __awaiter(this, void 0, void 0, function () {
            var e_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.get({
                                url: PATH + "/v1/draws/" + drawId + "/prizes"
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_5 = _a.sent();
                        throw e_5;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    PromotionsService.fetchPublishedDrawsByPromotion = function (promotion) {
        return __awaiter(this, void 0, void 0, function () {
            var e_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.get({
                                url: PATH + "/v1/draws/published-draws/" + promotion
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_6 = _a.sent();
                        throw e_6;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    PromotionsService.getDrawsforPromotionId = function (promotionId, page, size, sort) {
        return __awaiter(this, void 0, void 0, function () {
            var requestParams, url, response, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        requestParams = "size=" + size + "&";
                        if (page) {
                            requestParams = "page=" + page + "&" + requestParams;
                        }
                        requestParams = sort ? "sort=" + sort + "&" + requestParams : "sort=draw,desc&" + requestParams;
                        url = PATH + "/v1/promotion/" + promotionId + "/draws?" + requestParams;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api_1.API.get({
                                url: url
                            })];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, {
                                content: response.content,
                                page: {
                                    first: response.first,
                                    last: response.last,
                                    totalElements: response.totalElements,
                                    totalPages: response.totalPages,
                                    number: response.number
                                }
                            }];
                    case 3:
                        error_5 = _a.sent();
                        throw error_5;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return PromotionsService;
}());
exports.PromotionsService = PromotionsService;
//# sourceMappingURL=promotions-service.js.map